import React, { useState } from "react";
import { CloudSun } from "lucide-react";
import { weatherIconEmoji } from "../../utils/weatherEmoji";
import "../Clock/clockwidget.css";
import "./weatherwidget.css";
import { tr } from "../../../i18n";

const PREVIEWS = [
  {
    variant: "glass-card",
    label: tr("Glass card"),
    className: "de-weather-preview--glass",
    temp: "12°C",
    city: "Stockholm",
    desc: "Partly cloudy",
    iconCode: "02d",
  },
  {
    variant: "compact",
    label: tr("Compact"),
    className: "de-weather-preview--compact",
    temp: "12°C",
    city: "Stockholm",
    desc: "Partly cloudy",
    iconCode: "02d",
  },
  {
    variant: "minimal",
    label: tr("Minimal bar"),
    className: "de-weather-preview--minimal",
    temp: "12°C",
    city: "Stockholm",
    desc: "Partly cloudy",
    iconCode: "02d",
  },
];

/**
 * @param {{ onAddWeatherWidget: (variant: string) => void }} props
 */
function WeatherWidgetPicker({ onAddWeatherWidget }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="de-clock-picker de-weather-picker">
      <button
        type="button"
        className="de-clock-picker-btn de-weather-picker-btn"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <CloudSun size={18} aria-hidden />
        {tr("Add weather widget")}
      </button>

      {open && (
        <div className="de-clock-options">
          <p className="de-clock-options-title">{tr("Choose style")}</p>
          <div className="de-clock-option-grid">
            {PREVIEWS.map((p) => {
              const emoji = weatherIconEmoji(p.iconCode, p.desc);
              return (
                <div key={p.variant}>
                  <button
                    type="button"
                    className={`de-weather-card-preview ${p.className}`}
                    onClick={() => {
                      onAddWeatherWidget?.(p.variant);
                      setOpen(false);
                    }}
                  >
                    {p.variant === "minimal" ? (
                      <>
                        <span className="de-weather-preview-icon" aria-hidden>
                          {emoji}
                        </span>
                        <span className="de-weather-minimal-line">
                          {p.temp} · {p.desc} · {p.city}
                        </span>
                      </>
                    ) : p.variant === "compact" ? (
                      <>
                        <span className="de-weather-preview-icon de-weather-preview-icon--compact" aria-hidden>
                          {emoji}
                        </span>
                        <span className="de-weather-compact-meta">
                          <strong>{p.city}</strong>
                          <span className="de-weather-compact-temp">{p.temp}</span>
                          <span>{p.desc}</span>
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="de-weather-preview-icon de-weather-preview-icon--glass" aria-hidden>
                          {emoji}
                        </span>
                        <span className="de-weather-glass-city">{p.city}</span>
                        <span className="de-weather-glass-temp">{p.temp}</span>
                        <span className="de-weather-glass-desc">{p.desc}</span>
                      </>
                    )}
                  </button>
                  <p className="de-clock-option-label">{p.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default WeatherWidgetPicker;
